module.exports = __webpack_public_path__ + "static/media/cm1.80e58330.png";